<template>
	<div>
		<router-view v-show="$route.matched.length==3"></router-view>
		<PageHeaderLayout v-show="$route.matched.length==2" :class="this.isShow  ? 'filterBlur': ''">
			<div class="main-page-content">
				<el-row class="table-search">
					<el-form :inline="true" :model="searchCondition" class="demo-form-inline" v-if="userPermissions.indexOf('paihuo_examine_list') != -1">
						<el-form-item label="办理状态" prop="c_type">
							<el-select v-model="searchCondition.status" filterable clearable placeholder="请选择">
								<el-option
									v-for="item in typeList"
									:key="item.id"
									:label="item.name"
									:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="手机号码">
							<el-input v-model="searchCondition.contact_phone" placeholder="输入手机号码" clearable></el-input>
						</el-form-item>
						<el-form-item label="时间">
							<DatePicker @dataSearch="dataSearch" :disabled="disabled"/>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="searchButton" :disabled="disabled" >查询</el-button>
						</el-form-item>
					</el-form>
				</el-row>
				<el-tabs v-model="activeName" type="card" @tab-click="handleClick" v-if="userPermissions.indexOf('paihuo_examine_list') != -1">
					<el-tab-pane v-for="(item, index) in this.tabsList" :label="item.label" :key="index" :name="item.name" class="tab-item">
					</el-tab-pane>
				</el-tabs>
				<ApeTable ref="apeTable" :data="dataList" v-show="userPermissions.indexOf('paihuo_examine_list')!=-1?true:false" :columns="columns" :loading="loadingStaus" :pagingData="pagingData"  @switchPaging="switchPaging" highlight-current-row>
					<el-table-column
						slot="first-column"
						width="180"
						align="center"
						label="ID">
						<template slot-scope="scope">
							{{ scope.row.id }}
						</template>
					</el-table-column>
					<el-table-column
						align="center"
						:label="project_status?'用工企业':'公司名称'">
						<template slot-scope="scope">
							{{ scope.row.company_name }}
						</template>
					</el-table-column>
					<el-table-column
						align="center"
						:label="project_status?'企业联系手机号':'公司负责人手机号'">
						<template slot-scope="scope">
							{{ scope.row.contact_phone }}
						</template>
					</el-table-column>
					<el-table-column
						width="240"
						align="center"
						label="企业资质（营业执照/企业授权书）">
						<template slot-scope="scope">
							<img class="expressImg" :src="scope.row.business_license" @click="showImage(scope.row.business_license)" style="height: 50px;width: 80px;"/>
							<img class="expressImg" :src="item" v-for="(item,index) in scope.row.authorization" v-bind:key="index" @click="showImage(item)" style="margin-left: 10px;height: 50px;width: 80px;"/>
						</template>
					</el-table-column>
					<el-table-column
						width="240"
						align="center"
						:label="project_status?'公司主营业务':'公司承接范围'">
						<template slot-scope="scope">
							{{ scope.row.desc }}
						</template>
					</el-table-column>
					<el-table-column
						align="center"
						label="申请时间">
						<template slot-scope="scope">
							{{ scope.row.updated_at }}
						</template>
					</el-table-column>
					<el-table-column
						align="center"
						label="状态">
						<template slot-scope="scope">
              <div v-if="scope.row.user==null">数据不完整</div>
							<div v-if="project_status">
								<div>
									{{ scope.row.status=='2'?'资质审核拒绝':scope.row.status=='1'?'资质审核通过':'资质待审核'}}
								</div>
								<div>
									{{ scope.row.project_status>0?'项目有待审核':''}}
								</div>
							</div>
							<div v-else>
								{{ scope.row.status=='2'?'资质审核拒绝':scope.row.status=='1'?'资质审核通过':'资质待审核'}}
							</div>
						</template>
					</el-table-column>
					<el-table-column
						v-if="buttonType=='text'"
						width="250"
						header_align='center'
						align='center'
						label="操作">
						<template slot-scope="scope">
							<span>
								<el-button size="mini" type="primary" @click="examine(scope.row.id)" v-if="(scope.row.status=='0')&&(userPermissions.indexOf('paihuo_examine_audit') != -1)">审核</el-button>
								<el-button size="mini" type="primary" @click="toProject(scope.row.user.id,scope.row.company_name,scope.row.contact_phone,scope.row.status)" v-if="project_status">项目审核</el-button>
								<el-button size="mini" type="infor" v-if="userPermissions.indexOf('paihuo_examine_view') != -1" @click="toInfo(scope.row.id)">{{project_status?'企业详情':'公司详情'}}</el-button>
							</span>
						</template>
					</el-table-column>
				</ApeTable>
			</div>
		</PageHeaderLayout>
		<ModalDialog :dialogData="exDialogData" @dialogConfirm="handleConfirm" @dialogClose="dialogClose">
			<template slot="content">
				<el-form :model="refuseData" :rules="refuseRules" ref="refuseForm" label-position="right" label-width="96px">
					<el-form-item>
						<el-radio v-model="refuseData.status" label="1">审核通过</el-radio>
						<el-radio v-model="refuseData.status" label="2">审核拒绝</el-radio>
					</el-form-item>
					<el-form-item label="拒绝原因" prop="reason" v-if="this.refuseData.status==2">
						<el-input v-model="refuseData.reason" type="textarea" :rows="5" placeholder="请输入内容"></el-input>
					</el-form-item>
				</el-form>
			</template>
		</ModalDialog>
		<!-- 预览图片弹框 -->
		<el-dialog
			:title="'预览图片'"
			:visible.sync="imgDialogVisible"
			:modal="false"
			:width="'50%'"
		>
			<div class="block" v-if="imgDialogVisible">
				<img :src="this.imageUrl" style="width: 100%;height: auto" class="preview">
			</div>
		</el-dialog>
	</div >
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ApeDrawer from '@/components/ApeDrawer'
import ApeUploader from '@/components/ApeUploader'
import ModalDialog from '@/components/ModalDialog'
import DatePicker from '@/components/DatePicker.vue'
import { mapGetters } from 'vuex'

export default {
	components: {
		PageHeaderLayout,
		ApeDrawer,
		ApeTable,
		ApeUploader,
		ModalDialog,
		DatePicker
	},
	data() {
		return {
			disabled: false,
			showButton: ['cancel','determine'],    // 不显示弹窗框的按钮
			// element的cascader的props值
			cascaderProps:{
				label:'display_name',
				value:'id',
			},
			tableData: [],
			tableHeader: [],
			searchCategory: [],
			taskList: [],
			activeName: 'all',
			tabsList: [
				{
					label: '用工企业',
					name: 'all'
				},
				{
					label: '人力资源公司',
					name: 'cancel'
				},
			],
			// 搜索条件
			searchCondition:{
				status:'',
				contact_phone:'',
				time:''
			},
			typeList:[
				{id:'0',name:'资质待审核'},
				{id:'1',name:'资质已通过'},
				{id:'2',name:'资质未通过'}
			],
			loadingStaus: false,
			columns: [],
			// 表格列表数据
			dataList:[],
			// 分页信息
			pagingData:{
				is_show: true,
				layout: 'total, sizes, prev, pager, next, jumper',
				total: 0
			},
			// 分页的offset,序号列使用
			offset:0,
			// 已上传文件列表
			uploadFileList:[],
			// 附件列表
			attachmentList:[],
			// 添加附件
			dialogData:{
				visible: false,
				title: '系统提示',
				width: '35%',
				loading: false,
				modal: false
			},
			// 当前需要操作附件的文章id
			currentCompanyId:0,
			signTipsInfo: {
				'type': 0,
				'message': []
			},
			fontType: '',
			isShow: false,//是否模糊页面
			tipsTitle: '',
			description: [],
			project_status:true,
			exDialogData:{
				visible: false,
				title: '审核',
				width: '35%',
				loading: false,
				modal: false
			},
			refuseData:{
				reason:'抱歉，您当前没有通过企业资质审核'
			},
			refuseRules: {
				// reason: [
				// 	{ required: true, message: '请输入拒绝原因', trigger: 'blur' },
				// ]
			},
			imgDialogVisible: false,
			imageUrl: '',//图片地址
		}
	},
	computed: {
		...mapGetters(['userPermissions','buttonType'])
	},
	watch: {
		"$route.matched" : function(n,o) {
			console.log(n,o)
			if (n.length === 2) {
				this.init()
			}
			this.updateStatus(this.$route.query.project_status??true);
		}
	},
	methods: {
		// 重置分页
		async resetPage() {
			this.$refs.apeTable.currentPage = 1
		},
		//点击tab切换
		async handleClick(tab) {
			this.searchCondition={status:'',contact_phone:'',time:''};
			this.resetPage()
			if (tab.name == 'all') { // 全部批次
				// this.searchCondition.status = tab.name
				this.activeName = tab.name;
				this.init('all')
			} else if(tab.name == 'cancel') {  // 作废批次
				// this.searchCondition.status = tab.name
				this.init('cancel')
			}
		},
		// 搜索
		searchButton() {
			this.resetPage()
			this.init('search')
		},
		//导入调转
		importExcel() {
			this.$router.push({path: 'task/import'})
		},
		// 切换页码操作
		async switchPaging() {
			this.init()
		},
		// 响应添加按钮
		async addButton() {
			// this.$router.push(this.$route.path+'/create')
		},
		// 响应详情按钮
		async viewButton(id, type='') {
			if (type == '') {
				type = 'view'
			}
			this.mxRedirect(this.$route.path + '/' + id + '/' + type)
		},
		// 响应编辑按钮
		async editButton(id) {
			console.log(id)
			// this.$router.push(this.$route.path+'/'+id+'/edit')
		},
		//获取选中日期的值
		dataSearch(value) {
			this.searchCondition.time_value = value
		},
		// 初始化列表
		async init(type) {
			if(type=='cancel') {
				this.project_status = false;
			} else if(type=='all'){
				this.project_status = true;
			}
			this.loadingStaus=true
			let pagingInfo = this.$refs['apeTable'].getPagingInfo(type)
			let searchCondition = this.handleSearchCondition()
			Object.assign(searchCondition,pagingInfo)
			this.dataList = []
			if(!this.project_status) {
				this.hrList(searchCondition);
			} else {
				this.employList(searchCondition);
			}
			this.loadingStaus=false
		},
		// 用工企业列表数据
		async employList(searchCondition) {
			
			let {items, total}= await this.$api.getPaihuoEmploymentList(searchCondition)
			this.$nextTick(() => {
				this.dataList=items
			})
			this.pagingData.total = total
			this.offset = searchCondition.current_page
		},
		// 人力资源公司列表数据
		async hrList(searchCondition) {
			let {items, total}= await this.$api.getPaihuoHumanResourcesList(searchCondition)
			this.$nextTick(() => {
				this.dataList=items
				items.forEach(function(item,index){
					if(item.authorization&&item.authorization[1]) {
						items[index].authorization_img = item.authorization[1];
					} else {
						items[index].authorization_img = "";
					}
				})
			})
			this.pagingData.total = total
			this.offset = searchCondition.current_page
		},
		// 处理搜索条件
		handleSearchCondition() {
			let condition = {}
			if (this.searchCondition.status) {
				condition.status = this.searchCondition.status
			}
			if (this.searchCondition.contact_phone) {
				condition.contact_phone = this.searchCondition.contact_phone
			}
			if (this.searchCondition.time_value) {
				condition.start_time = this.searchCondition.time_value[0]
				condition.end_time = this.searchCondition.time_value[1]
			}
			return condition
		},
		keyupSubmit(){
			document.onkeydown = e => {
				console.log(e)
				let _key=window.event.keyCode;
				if(_key === 13){
					this.searchButton()
				}
			}
		},
		// 项目审核列表
		toProject(id,name,contact_phone,status){
			console.log(status)
			this.$router.push({
				path:'/paihuo/paihuo_project',
				query:{ id: id,company_name:name,contact_phone:contact_phone,status:status}
			})
		},
		// 公司详情
		toInfo(id){
			console.log(id)
			this.$router.push({
				path: "/paihuo/info",
				query: { project_status: this.project_status, id: id}
			})
		},
		// 处理模态框，确定事件
		handleConfirm() {
			// 调用组件的数据验证方法
			this.$refs['refuseForm'].validate((valid) => {
				if (valid) {
					if(!this.refuseData.status) {
						this.$message.error('请选择审核通过或拒绝！')
						return false;
					}
					if(this.refuseData.status==1) {
						this.refuseData.reason = "";
					}
				this.formRefuseSubmit()
				} else {
					this.$message.error('数据验证失败，请检查必填项数据！')
				}
			})
		},
		// 处理模态框，关闭事件
		dialogClose() {
			this.exDialogData.visible = false
			// this.formData = {}
			// this.attachmentUploadFileList = []
			this.refuseData = {reason:"抱歉，您当前没有通过企业资质审核"}
		},
		// 审核公司
		examine(id){
			this.refuseData={reason:"抱歉，您当前没有通过企业资质审核"};
			this.exDialogData.visible = true
			this.refuseData.id = id
		},
		/* 预览图片 */
		showImage(data) {
			this.imgDialogVisible = true;
			this.imageUrl = data;
		},
		async updateStatus(project_status){
			this.project_status = project_status;
		},
		// 审核数据提交
		async formRefuseSubmit() {
			var data = {};
			data.status = this.refuseData.status;
			data.reason = this.refuseData.reason;
			if(this.project_status) {
				const res = await this.$api.examinePaihuoEmployment(this.refuseData.id,data)
				if (res) {
					this.$message.success('操作成功。')
					this.exDialogData.visible = false
					this.exDialogData.loading = false
				} else {
					this.$message.error('审核失败。')
				}
				this.init('all')
			} else {
				const res = await this.$api.examinePaihuoHumansources(this.refuseData.id,data)
				if (res) {
					this.$message.success('操作成功。')
					this.exDialogData.visible = false
					this.exDialogData.loading = false
				} else {
					this.$message.error('审核失败。')
				}
				this.init('cancel')
			}
		}
	},
	created() {
		this.keyupSubmit()
	},
	mounted() {
		this.resetPage()
		this.init();
		this.updateStatus(true);
	},
}
</script>

<style lang="stylus" scoped>
	.expressImg
		width:100px
		height:auto
  .el-button
    margin-right 4px
    margin-bottom 4px
  .el-button + .el-button
    margin-left: 0
  .table-header
    margin-bottom 12px
  .el-popover .el-checkbox-group .el-checkbox
    margin-left 0px
    margin-right 12px
  .submitBtn
    float: right
    margin-top: 20px
  .link-url
    color: #fff
    text-decoration:none
  .iconBtns
    font-size: 20px
    color: rgba(0, 183, 158, 1)
  .warning-tips
    padding: 15px 5px
    padding-bottom: 25px
    color: #E6A23C
    font-size: 16px
  .error-tips
    font-size: 16px
    padding: 15px 5px
    padding-bottom: 25px
  .filterBlur
    filter: blur(5px)
    -moz-filter: blur(5px)
    -webkit-filter: blur(5px)
  .icon-btn
    font-size: 45px
  /deep/.el-alert__icon
    font-size: 45px
    margin-left: -15px
  /deep/.el-alert__content
    margin-left: 40px
  /deep/.el-alert__title
    font-size: 16px
  /deep/.el-alert
    padding: 0px 25px
  /deep/.el-alert--error.is-light,
  /deep/.el-alert--warning.is-light
    background: #fff
  /deep/.el-alert__title.is-bold
    font-weight: normal
  /deep/.el-alert__description
    font-size: 16px
  /deep/.el-alert__title
    line-height: 30px
  .tips-center
    justify-content: center
	// .table-search
	
</style>
